import React from 'react';

export const StatusEnquiryHeader = ({
    title,
    subtitle,
    icon = 'ri-file-list-3-line',
    badgeColor = 'primary',
    badgeLabel = 'Total Records',
    count = 0,
    districtList = [],
    selectedDistrict = 'all',
    setSelectedDistrict,
    searchTerm,
    setSearchTerm
}) => {
    return (
        <div className="card-header bg-transparent py-3 px-3 px-md-4 border-bottom">
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                {/* Title & Badge */}
                <div className="d-flex align-items-center gap-2 flex-wrap">
                    <div className="d-flex align-items-center gap-1.5">
                        <i className={`${icon} text-${badgeColor} fs-18`} />
                        <h5 className="card-title mb-0 fs-16 fw-bold text-body">{title}</h5>
                    </div>
                    <span className={`badge bg-soft-${badgeColor} text-${badgeColor} fs-11 px-2.5 py-1 fw-semibold`}>
                        {badgeLabel}: {count}
                    </span>
                </div>

                {/* Filters: District Filter + Search Bar */}
                <div className="d-flex align-items-center gap-2 flex-wrap">
                    {/* District Dropdown (if districts exist) */}
                    {districtList && districtList.length > 0 && setSelectedDistrict && (
                        <div className="d-flex align-items-center gap-1.5">
                            <span className="fs-12 text-muted fw-medium text-nowrap">
                                <i className="ri-building-line me-1" />
                                District:
                            </span>
                            <select
                                className="form-select form-select-sm fs-12"
                                style={{ width: 'auto', minWidth: '135px' }}
                                value={selectedDistrict}
                                onChange={(e) => setSelectedDistrict(e.target.value)}
                            >
                                <option value="all">All Districts</option>
                                {districtList.map((dist) => (
                                    <option key={dist} value={dist}>
                                        {dist}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}

                    {/* Search Bar */}
                    <div className="position-relative" style={{ minWidth: '200px', maxWidth: '300px' }}>
                        <input
                            type="text"
                            className="form-control form-control-sm fs-12 ps-4"
                            placeholder="Search school, phone..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <i className="ri-search-line position-absolute top-50 start-0 translate-middle-y ms-2 text-muted fs-13" />
                        {searchTerm && (
                            <button
                                type="button"
                                className="btn btn-sm btn-link position-absolute top-50 end-0 translate-middle-y p-0 me-2 text-muted"
                                onClick={() => setSearchTerm('')}
                            >
                                <i className="ri-close-line fs-14" />
                            </button>
                        )}
                    </div>
                </div>
            </div>
            {subtitle && (
                <p className="text-muted fs-12 mb-0 mt-1">
                    {subtitle}
                </p>
            )}
        </div>
    );
};

export default StatusEnquiryHeader;
